// generated from 2_470 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xSpecificPurchaseInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_specific_purchase_in_y_days"),
  comparison_key: z.enum([
    "3", // 1_431 (57.94%)
    "1", // 717 (29.03%)
    "5", // 322 (13.04%)
  ]),
  display_name: z.string(),
  // undefined: 849 (34.37%), defined 1_621 (65.63%)
  raw_value: z
    .object({
      // avg: 13.90, min: 1, max: 30
      num_days: z.int().min(1).max(30),
      num_occurrences: z.int().min(0),
    })
    .optional(),
  value: z.object({
    // avg: 13.73, min: 1, max: 30
    num_days: z.int().min(1).max(30),
    num_occurrences: z.int().min(0),
  }),
  varies_by_app_group: z.literal(true),
});
